import { useState, useContext, useEffect } from 'react';
import { RiEdit2Fill } from "react-icons/ri";

import ViewProfile from '../../components/Employer Portal/Profiles/ViewProfile';
import UpdateProfile from '../../components/Employer Portal/Profiles/UpdateProfile';

import ViewUser from '../../components/Profiles/ViewUser';
import UpdateUser from '../../components/Profiles/UpdateUser';

import { DataProvider } from '../../store/ContextProvider';
import Loading from '../Loading';

import Profiles from '../../components/Candidate Info/ViewProfiles';
import ErrorBadge from '../../components/ErrorBadge';
import { fetchCandidate } from '../../services/Candidate Portal/Profile/fetchCandidateDetails';

export default function MyAccount() {
    const { currentUser, setCurrentUser, BeURL } = useContext(DataProvider);
    
    const queryParams = new URLSearchParams(window.location.search);
    const updateStatus = queryParams ? queryParams.get("updateStatus") : "";

    const [editUser, setEditUser] = useState(false)
    const [candidate, setCandidate] = useState(null);
    const [error, setError] = useState(null);
    const [isReadOnly, setIsReadOnly] = useState(true)

    useEffect(() => {
        if (BeURL){
            fetchCandidate(BeURL, currentUser, setCandidate, setError)
        }
    }, [BeURL]);

    useEffect(()=>{
        if (updateStatus && updateStatus === "1"){
            setIsReadOnly(false)
        }
    },[updateStatus])

    if (!currentUser || !candidate) return <Loading/>;


    if (error) return <ErrorBadge error={error} />

    return (
        <main className=' '>

            {currentUser?.role === "job-seeker" && <Profiles candidate={candidate} />}

            <h4 className='text-xl text-slate-800 font-semibold my-4'>
                {
                    !editUser ?
                        <span className='flex gap-4 items-center justify-center'>Login Details <RiEdit2Fill className='cursor-pointer hover:scale-110 transition-all text-slate-600' onClick={() => setEditUser(true)} /></span> :
                        <span className='flex gap-4 items-center justify-center'>Update Login Details</span>
                }
            </h4>
            {!editUser ? <ViewUser currentUser={currentUser} setCurrentUser={setCurrentUser} editUser={editUser} setEditUser={setEditUser} />
                : <UpdateUser currentUser={currentUser} setCurrentUser={setCurrentUser} editUser={editUser} setEditUser={setEditUser} />}



            {
                currentUser.role === "employer" && (

                    <>
                        <h4 className='text-xl font-semibold my-4 text-primary-400'>
                            {
                                isReadOnly ?
                                    <span className='flex gap-4 items-center'>Employer Details <RiEdit2Fill className='cursor-pointer hover:scale-110 transition-all text-slate-600' onClick={() => setIsReadOnly(false)} /></span> :
                                    <span className='flex gap-4 items-center justify-center'>Update Employer Details</span>
                            }
                        </h4>
                        {isReadOnly ? <ViewProfile userData={candidate} setCandidate={setCandidate} isReadOnly={isReadOnly} setIsReadOnly={setIsReadOnly} />
                            : <UpdateProfile userData={candidate} setUserData={setCandidate} isReadOnly={isReadOnly} setIsReadOnly={setIsReadOnly} />}
                    </>

                )
            }

        </main>
    );
}